import React from 'react';
import { Perk } from '../../components';

const PerksList = ({
  perks, planType, fetchPerkCode, selectedPerks, selectedPerk, submitting, error, subscription
}) => (
  <div className="perks-list">
    {
      perks.map(perk =>
        (<Perk
          key={perk}
          perk={perk}
          planType={planType}
          fetchPerkCode={fetchPerkCode}
          selectedPerks={selectedPerks}
          selectedPerk={selectedPerk}
          submitting={submitting}
          error={error}
          subscription={subscription}
        />))
    }
  </div>
);

export default PerksList;

